import { ApplicantInterviewers } from '@app/models/recruiting/applicant-interviewers.model';
import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { Translatable } from '@app/types/translatable.type';

export class SubmittedColumn extends Column {
    title = 'applicant-tracker.submitted';
    property = 'isSubmitted';
    sortable = true;
    type: CellDisplay = CellDisplay.string;

    getDisplayPropertyValue(applicantInterviewer: ApplicantInterviewers): Translatable {
        return applicantInterviewer.isSubmitted ? 'yes' : 'no';
    }
}
